import { type AxiosResponse } from 'axios'

import { type CustomAxiosConfig } from '@/types/axios'
import { type Booking, type BookingService } from '@/types/Booking'
import { type PaginationResponse } from '@/types/Pagination'

import armSecureAxios from './secure-base'

export interface CreateBookingData {
  service_id: string
  visit_date: string
  visit_time: number
  symptoms?: string
  doctor_id?: string
  room_id?: string
  room_start_date?: string
  room_end_date?: string
  patient_first_name: string
  patient_last_name: string
  patient_phone: string
  patient_email?: string
  insurance_company?: string
  policy_number?: string
  is_patient_vip: boolean
}

export const createBooking = async (data: CreateBookingData, config?: CustomAxiosConfig): Promise<AxiosResponse<BookingService[]>> => {
  return await armSecureAxios.post('/bookings', data, { ...config })
}

export const fetchBooking = async (id: string, config?: CustomAxiosConfig): Promise<AxiosResponse<Booking>> => {
  return await armSecureAxios.get(`/bookings/${id}`, { ...config })
}

export const fetchBookings = async (page: number, config?: CustomAxiosConfig): Promise<AxiosResponse<PaginationResponse<Booking>>> => {
  return await armSecureAxios.get('/bookings', { ...config, params: { page } })
}

export interface CancelBookingData {
  booking_status_reason?: string
}

export const cancelBooking = async (bookingId: string, data: CancelBookingData, config?: CustomAxiosConfig): Promise<AxiosResponse<unknown>> => {
  return await armSecureAxios.post(`/bookings/${bookingId}/cancel`, data, { ...config })
}

const bookingArmService = {
  createBooking,
  fetchBooking,
  fetchBookings,
  cancelBooking
}

export default bookingArmService
